// Mock Data for PractiQ - GST Simulation Lab

export const states = [
  { code: '01', name: 'Jammu and Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' }
];

export const districts = {
  // Jammu and Kashmir (01)
  '01': ['Anantnag', 'Bandipora', 'Baramulla', 'Budgam', 'Doda', 'Ganderbal', 'Jammu', 'Kathua', 'Kishtwar', 'Kulgam', 'Kupwara', 'Poonch', 'Pulwama', 'Rajouri', 'Ramban', 'Reasi', 'Samba', 'Shopian', 'Srinagar', 'Udhampur'],
  // Himachal Pradesh (02)
  '02': ['Bilaspur', 'Chamba', 'Hamirpur', 'Kangra', 'Kinnaur', 'Kullu', 'Lahaul and Spiti', 'Mandi', 'Shimla', 'Sirmaur', 'Solan', 'Una'],
  // Punjab (03)
  '03': ['Amritsar', 'Barnala', 'Bathinda', 'Faridkot', 'Fatehgarh Sahib', 'Fazilka', 'Ferozepur', 'Gurdaspur', 'Hoshiarpur', 'Jalandhar', 'Kapurthala', 'Ludhiana', 'Malerkotla', 'Mansa', 'Moga', 'Mohali', 'Muktsar', 'Nawanshahr', 'Pathankot', 'Patiala', 'Rupnagar', 'Sangrur', 'Tarn Taran'],
  // Chandigarh (04)
  '04': ['Chandigarh'],
  // Uttarakhand (05)
  '05': ['Almora', 'Bageshwar', 'Chamoli', 'Champawat', 'Dehradun', 'Haridwar', 'Nainital', 'Pauri Garhwal', 'Pithoragarh', 'Rudraprayag', 'Tehri Garhwal', 'Udham Singh Nagar', 'Uttarkashi'],
  // Haryana (06)
  '06': ['Ambala', 'Bhiwani', 'Charkhi Dadri', 'Faridabad', 'Fatehabad', 'Gurugram', 'Hisar', 'Jhajjar', 'Jind', 'Kaithal', 'Karnal', 'Kurukshetra', 'Mahendragarh', 'Nuh', 'Palwal', 'Panchkula', 'Panipat', 'Rewari', 'Rohtak', 'Sirsa', 'Sonipat', 'Yamunanagar'],
  // Delhi (07)
  '07': ['Central Delhi', 'East Delhi', 'New Delhi', 'North Delhi', 'North East Delhi', 'North West Delhi', 'Shahdara', 'South Delhi', 'South East Delhi', 'South West Delhi', 'West Delhi'],
  // Rajasthan (08)
  '08': ['Ajmer', 'Alwar', 'Banswara', 'Baran', 'Barmer', 'Bharatpur', 'Bhilwara', 'Bikaner', 'Bundi', 'Chittorgarh', 'Churu', 'Dausa', 'Dholpur', 'Dungarpur', 'Hanumangarh', 'Jaipur', 'Jaisalmer', 'Jalore', 'Jhalawar', 'Jhunjhunu', 'Jodhpur', 'Karauli', 'Kota', 'Nagaur', 'Pali', 'Pratapgarh', 'Rajsamand', 'Sawai Madhopur', 'Sikar', 'Sirohi', 'Sri Ganganagar', 'Tonk', 'Udaipur'],
  // Uttar Pradesh (09)
  '09': ['Agra', 'Aligarh', 'Allahabad', 'Ambedkar Nagar', 'Amethi', 'Amroha', 'Auraiya', 'Azamgarh', 'Baghpat', 'Bahraich', 'Ballia', 'Balrampur', 'Banda', 'Barabanki', 'Bareilly', 'Basti', 'Bijnor', 'Budaun', 'Bulandshahr', 'Chandauli', 'Chitrakoot', 'Deoria', 'Etah', 'Etawah', 'Faizabad', 'Farrukhabad', 'Fatehpur', 'Firozabad', 'Gautam Buddha Nagar', 'Ghaziabad', 'Ghazipur', 'Gonda', 'Gorakhpur', 'Hamirpur', 'Hapur', 'Hardoi', 'Hathras', 'Jalaun', 'Jaunpur', 'Jhansi', 'Kannauj', 'Kanpur Dehat', 'Kanpur Nagar', 'Kasganj', 'Kaushambi', 'Kushinagar', 'Lakhimpur Kheri', 'Lalitpur', 'Lucknow', 'Maharajganj', 'Mahoba', 'Mainpuri', 'Mathura', 'Mau', 'Meerut', 'Mirzapur', 'Moradabad', 'Muzaffarnagar', 'Pilibhit', 'Pratapgarh', 'Raebareli', 'Rampur', 'Saharanpur', 'Sambhal', 'Sant Kabir Nagar', 'Shahjahanpur', 'Shamli', 'Shravasti', 'Siddharthnagar', 'Sitapur', 'Sonbhadra', 'Sultanpur', 'Unnao', 'Varanasi'],
  // Bihar (10)
  '10': ['Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai', 'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran', 'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur', 'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura', 'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada', 'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur', 'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan', 'Supaul', 'Vaishali', 'West Champaran'],
  // Sikkim (11)
  '11': ['East Sikkim', 'North Sikkim', 'South Sikkim', 'West Sikkim', 'Pakyong', 'Soreng'],
  // Arunachal Pradesh (12)
  '12': ['Anjaw', 'Changlang', 'Dibang Valley', 'East Kameng', 'East Siang', 'Itanagar Capital Complex', 'Kamle', 'Kra Daadi', 'Kurung Kumey', 'Lepa Rada', 'Lohit', 'Longding', 'Lower Dibang Valley', 'Lower Siang', 'Lower Subansiri', 'Namsai', 'Pakke Kessang', 'Papum Pare', 'Shi Yomi', 'Siang', 'Tawang', 'Tirap', 'Upper Siang', 'Upper Subansiri', 'West Kameng', 'West Siang'],
  // Nagaland (13)
  '13': ['Chümoukedima', 'Dimapur', 'Kiphire', 'Kohima', 'Longleng', 'Mokokchung', 'Mon', 'Noklak', 'Peren', 'Phek', 'Tuensang', 'Wokha', 'Zunheboto'],
  // Manipur (14)
  '14': ['Bishnupur', 'Chandel', 'Churachandpur', 'Imphal East', 'Imphal West', 'Jiribam', 'Kakching', 'Kamjong', 'Kangpokpi', 'Noney', 'Pherzawl', 'Senapati', 'Tamenglong', 'Tengnoupal', 'Thoubal', 'Ukhrul'],
  // Mizoram (15)
  '15': ['Aizawl', 'Champhai', 'Hnahthial', 'Khawzawl', 'Kolasib', 'Lawngtlai', 'Lunglei', 'Mamit', 'Saiha', 'Saitual', 'Serchhip'],
  // Tripura (16)
  '16': ['Dhalai', 'Gomati', 'Khowai', 'North Tripura', 'Sepahijala', 'South Tripura', 'Unakoti', 'West Tripura'],
  // Meghalaya (17)
  '17': ['East Garo Hills', 'East Jaintia Hills', 'East Khasi Hills', 'North Garo Hills', 'Ri Bhoi', 'South Garo Hills', 'South West Garo Hills', 'South West Khasi Hills', 'West Garo Hills', 'West Jaintia Hills', 'West Khasi Hills'],
  // Assam (18)
  '18': ['Baksa', 'Barpeta', 'Biswanath', 'Bongaigaon', 'Cachar', 'Charaideo', 'Chirang', 'Darrang', 'Dhemaji', 'Dhubri', 'Dibrugarh', 'Dima Hasao', 'Goalpara', 'Golaghat', 'Hailakandi', 'Hojai', 'Jorhat', 'Kamrup', 'Kamrup Metropolitan', 'Karbi Anglong', 'Karimganj', 'Kokrajhar', 'Lakhimpur', 'Majuli', 'Morigaon', 'Nagaon', 'Nalbari', 'Sivasagar', 'Sonitpur', 'South Salmara-Mankachar', 'Tinsukia', 'Udalguri', 'West Karbi Anglong'],
  // West Bengal (19)
  '19': ['Alipurduar', 'Bankura', 'Birbhum', 'Cooch Behar', 'Dakshin Dinajpur', 'Darjeeling', 'Hooghly', 'Howrah', 'Jalpaiguri', 'Jhargram', 'Kalimpong', 'Kolkata', 'Malda', 'Murshidabad', 'Nadia', 'North 24 Parganas', 'Paschim Bardhaman', 'Paschim Medinipur', 'Purba Bardhaman', 'Purba Medinipur', 'Purulia', 'South 24 Parganas', 'Uttar Dinajpur'],
  // Jharkhand (20)
  '20': ['Bokaro', 'Chatra', 'Deoghar', 'Dhanbad', 'Dumka', 'East Singhbhum', 'Garhwa', 'Giridih', 'Godda', 'Gumla', 'Hazaribagh', 'Jamtara', 'Khunti', 'Koderma', 'Latehar', 'Lohardaga', 'Pakur', 'Palamu', 'Ramgarh', 'Ranchi', 'Sahebganj', 'Seraikela Kharsawan', 'Simdega', 'West Singhbhum'],
  // Odisha (21)
  '21': ['Angul', 'Balangir', 'Balasore', 'Bargarh', 'Bhadrak', 'Boudh', 'Cuttack', 'Deogarh', 'Dhenkanal', 'Gajapati', 'Ganjam', 'Jagatsinghpur', 'Jajpur', 'Jharsuguda', 'Kalahandi', 'Kandhamal', 'Kendrapara', 'Kendujhar', 'Khordha', 'Koraput', 'Malkangiri', 'Mayurbhanj', 'Nabarangpur', 'Nayagarh', 'Nuapada', 'Puri', 'Rayagada', 'Sambalpur', 'Subarnapur', 'Sundargarh'],
  // Chhattisgarh (22)
  '22': ['Balod', 'Baloda Bazar', 'Balrampur', 'Bastar', 'Bemetara', 'Bijapur', 'Bilaspur', 'Dantewada', 'Dhamtari', 'Durg', 'Gariaband', 'Gaurela Pendra Marwahi', 'Janjgir Champa', 'Jashpur', 'Kabirdham', 'Kanker', 'Kondagaon', 'Korba', 'Koriya', 'Mahasamund', 'Mungeli', 'Narayanpur', 'Raigarh', 'Raipur', 'Rajnandgaon', 'Sukma', 'Surajpur', 'Surguja'],
  // Madhya Pradesh (23)
  '23': ['Agar Malwa', 'Alirajpur', 'Anuppur', 'Ashoknagar', 'Balaghat', 'Barwani', 'Betul', 'Bhind', 'Bhopal', 'Burhanpur', 'Chhatarpur', 'Chhindwara', 'Damoh', 'Datia', 'Dewas', 'Dhar', 'Dindori', 'Guna', 'Gwalior', 'Harda', 'Hoshangabad', 'Indore', 'Jabalpur', 'Jhabua', 'Katni', 'Khandwa', 'Khargone', 'Mandla', 'Mandsaur', 'Morena', 'Narsinghpur', 'Neemuch', 'Niwari', 'Panna', 'Raisen', 'Rajgarh', 'Ratlam', 'Rewa', 'Sagar', 'Satna', 'Sehore', 'Seoni', 'Shahdol', 'Shajapur', 'Sheopur', 'Shivpuri', 'Sidhi', 'Singrauli', 'Tikamgarh', 'Ujjain', 'Umaria', 'Vidisha'],
  // Gujarat (24)
  '24': ['Ahmedabad', 'Amreli', 'Anand', 'Aravalli', 'Banaskantha', 'Bharuch', 'Bhavnagar', 'Botad', 'Chhota Udaipur', 'Dahod', 'Dang', 'Devbhoomi Dwarka', 'Gandhinagar', 'Gir Somnath', 'Jamnagar', 'Junagadh', 'Kheda', 'Kutch', 'Mahisagar', 'Mehsana', 'Morbi', 'Narmada', 'Navsari', 'Panchmahal', 'Patan', 'Porbandar', 'Rajkot', 'Sabarkantha', 'Surat', 'Surendranagar', 'Tapi', 'Vadodara', 'Valsad'],
  // Maharashtra (27)
  '27': ['Ahmednagar', 'Akola', 'Amravati', 'Aurangabad', 'Beed', 'Bhandara', 'Buldhana', 'Chandrapur', 'Dhule', 'Gadchiroli', 'Gondia', 'Hingoli', 'Jalgaon', 'Jalna', 'Kolhapur', 'Latur', 'Mumbai City', 'Mumbai Suburban', 'Nagpur', 'Nanded', 'Nandurbar', 'Nashik', 'Osmanabad', 'Palghar', 'Parbhani', 'Pune', 'Raigad', 'Ratnagiri', 'Sangli', 'Satara', 'Sindhudurg', 'Solapur', 'Thane', 'Wardha', 'Washim', 'Yavatmal'],
  // Karnataka (29)
  '29': ['Bagalkot', 'Ballari', 'Belagavi', 'Bengaluru Rural', 'Bengaluru Urban', 'Bidar', 'Chamarajanagar', 'Chikkaballapur', 'Chikkamagaluru', 'Chitradurga', 'Dakshina Kannada', 'Davanagere', 'Dharwad', 'Gadag', 'Hassan', 'Haveri', 'Kalaburagi', 'Kodagu', 'Kolar', 'Koppal', 'Mandya', 'Mysuru', 'Raichur', 'Ramanagara', 'Shivamogga', 'Tumakuru', 'Udupi', 'Uttara Kannada', 'Vijayanagara', 'Vijayapura', 'Yadgir'],
  // Goa (30)
  '30': ['North Goa', 'South Goa'],
  // Kerala (32)
  '32': ['Alappuzha', 'Ernakulam', 'Idukki', 'Kannur', 'Kasaragod', 'Kollam', 'Kottayam', 'Kozhikode', 'Malappuram', 'Palakkad', 'Pathanamthitta', 'Thiruvananthapuram', 'Thrissur', 'Wayanad'],
  // Tamil Nadu (33)
  '33': ['Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri', 'Dindigul', 'Erode', 'Kallakurichi', 'Kancheepuram', 'Karur', 'Krishnagiri', 'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai', 'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 'Tenkasi', 'Thanjavur', 'Theni', 'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupathur', 'Tiruppur', 'Tiruvallur', 'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Viluppuram', 'Virudhunagar'],
  // Telangana (36)
  '36': ['Adilabad', 'Bhadradri Kothagudem', 'Hyderabad', 'Jagtial', 'Jangaon', 'Jayashankar Bhupalpally', 'Jogulamba Gadwal', 'Kamareddy', 'Karimnagar', 'Khammam', 'Komaram Bheem', 'Mahabubabad', 'Mahabubnagar', 'Mancherial', 'Medak', 'Medchal–Malkajgiri', 'Mulugu', 'Nagarkurnool', 'Nalgonda', 'Narayanpet', 'Nirmal', 'Nizamabad', 'Peddapalli', 'Rajanna Sircilla', 'Rangareddy', 'Sangareddy', 'Siddipet', 'Suryapet', 'Vikarabad', 'Wanaparthy', 'Warangal Rural', 'Warangal Urban', 'Yadadri Bhuvanagiri'],
  // Andhra Pradesh (37)
  '37': ['Alluri Sitharama Raju', 'Anakapalli', 'Ananthapuramu', 'Annamayya', 'Bapatla', 'Chittoor', 'East Godavari', 'Eluru', 'Guntur', 'Kadapa', 'Kakinada', 'Konaseema', 'Krishna', 'Kurnool', 'Nandyal', 'NTR', 'Palnadu', 'Parvathipuram Manyam', 'Prakasam', 'Srikakulam', 'Sri Potti Sriramulu Nellore', 'Sri Sathya Sai', 'Tirupati', 'Visakhapatnam', 'Vizianagaram', 'West Godavari']
};

export const taxpayerTypes = [
  'Taxpayer',
  'Tax Deductor',
  'Tax Collector (e-Commerce)',
  'GST Practitioner',
  'Non Resident Taxable Person',
  'United Nation Body',
  'Consulate or Embassy of Foreign Country',
  'Other Notified Person',
  'Non-Resident Online Services Provider'
];

export const gstRates = [
  { rate: 0, label: '0%' },
  { rate: 0.25, label: '0.25%' },
  { rate: 3, label: '3%' },
  { rate: 5, label: '5%' },
  { rate: 12, label: '12%' },
  { rate: 18, label: '18%' },
  { rate: 28, label: '28%' }
];

export const gstr1Tiles = [
  { id: '4A', title: '4A, 4B, 4C, 6B, 6C - B2B Invoices', description: 'Taxable outward supplies to registered persons', icon: 'FileText', color: '#1976D2' },
  { id: '5A', title: '5A, 5B - B2C (Large) Invoices', description: 'Taxable outward inter-state supplies > 2.5 Lakh', icon: 'FileSpreadsheet', color: '#388E3C' },
  { id: '6A', title: '6A - Exports Invoices', description: 'Export supplies with/without payment', icon: 'Plane', color: '#F57C00' },
  { id: '7', title: '7 - B2C (Others)', description: 'Taxable supplies to unregistered persons', icon: 'Users', color: '#7B1FA2' },
  { id: '8', title: '8 - Nil Rated Supplies', description: 'Nil rated, exempted and non-GST supplies', icon: 'FileX', color: '#455A64' },
  { id: '9B', title: '9B - Credit/Debit Notes (Registered)', description: 'Amendments to B2B invoices', icon: 'FileEdit', color: '#C62828' },
  { id: '9C', title: '9C - Credit/Debit Notes (Unregistered)', description: 'Amendments to B2C invoices', icon: 'FileMinus', color: '#AD1457' },
  { id: '10', title: '10 - Amended B2B Invoices', description: 'Amendment to B2B invoices of earlier period', icon: 'RefreshCw', color: '#00695C' },
  { id: '11A1', title: '11A(1) - Advance Received', description: 'Tax liability on advance received', icon: 'ArrowDownCircle', color: '#1565C0' },
  { id: '11A2', title: '11A(2) - Advance Adjusted', description: 'Adjustment of advances against invoices', icon: 'ArrowUpCircle', color: '#6A1B9A' },
  { id: '12', title: '12 - HSN-wise Summary', description: 'HSN-wise summary of outward supplies', icon: 'BarChart3', color: '#2E7D32' },
  { id: '13', title: '13 - Documents Issued', description: 'Summary of documents issued during tax period', icon: 'FileCheck', color: '#E65100' }
];

export const gstr3bTiles = [
  { id: '3.1', title: '3.1 Tax on outward and reverse charge inward supplies', sections: [
    { key: 'a', label: '(a) Outward taxable supplies (other than zero rated, nil rated and exempted)' },
    { key: 'b', label: '(b) Outward taxable supplies (zero rated)' },
    { key: 'c', label: '(c) Other outward supplies (Nil rated, exempted)' },
    { key: 'd', label: '(d) Inward supplies (liable to reverse charge)' },
    { key: 'e', label: '(e) Non-GST outward supplies' }
  ]},
  { id: '3.2', title: '3.2 Inter-state supplies', sections: [
    { key: 'unreg', label: 'Supplies made to Unregistered Persons' },
    { key: 'comp', label: 'Supplies made to Composition Taxable Persons' },
    { key: 'uin', label: 'Supplies made to UIN holders' }
  ]},
  { id: '4', title: '4. Eligible ITC', sections: [
    { key: 'A', label: '(A) ITC Available (whether in full or part)', subsections: [
      { key: '1', label: '(1) Import of goods' },
      { key: '2', label: '(2) Import of services' },
      { key: '3', label: '(3) Inward supplies liable to reverse charge' },
      { key: '4', label: '(4) Inward supplies from ISD' },
      { key: '5', label: '(5) All other ITC' }
    ]},
    { key: 'B', label: '(B) ITC Reversed', subsections: [
      { key: '1', label: '(1) As per rules 42 & 43 of CGST Rules' },
      { key: '2', label: '(2) Others' }
    ]},
    { key: 'C', label: '(C) Net ITC Available (A) - (B)' },
    { key: 'D', label: '(D) Other Details', subsections: [
      { key: '1', label: '(1) ITC reclaimed' },
      { key: '2', label: '(2) Ineligible ITC u/s 16(4) & ITC restricted due to PoS rules' }
    ]}
  ]},
  { id: '5', title: '5. Values of exempt, nil-rated and non-GST inward supplies', sections: [
    { key: 'inter', label: 'Inter-State supplies' },
    { key: 'intra', label: 'Intra-State supplies' }
  ]},
  { id: '5.1', title: '5.1 Interest and Late fee', sections: [
    { key: 'interest', label: 'Interest' },
    { key: 'latefee', label: 'Late Fee' }
  ]},
  { id: '6.1', title: '6.1 Payment of Tax', sections: [
    { key: 'igst', label: 'Integrated Tax' },
    { key: 'cgst', label: 'Central Tax' },
    { key: 'sgst', label: 'State/UT Tax' },
    { key: 'cess', label: 'CESS' }
  ]}
];

export const hsnCodes = [
  { code: '0101', description: 'Live horses, asses, mules and hinnies' },
  { code: '0201', description: 'Meat of bovine animals, fresh or chilled' },
  { code: '0401', description: 'Milk and cream, not concentrated' },
  { code: '0901', description: 'Coffee, whether or not roasted' },
  { code: '1001', description: 'Wheat and meslin' },
  { code: '2201', description: 'Waters, including natural or artificial mineral waters' },
  { code: '3004', description: 'Medicaments' },
  { code: '6109', description: 'T-shirts, singlets and other vests, knitted or crocheted' },
  { code: '8471', description: 'Automatic data processing machines and units' },
  { code: '8517', description: 'Telephone sets, smartphones' },
  { code: '8703', description: 'Motor cars and other motor vehicles' },
  { code: '9401', description: 'Seats and parts thereof' },
  { code: '9403', description: 'Other furniture and parts thereof' }
];

export const generateTRN = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let trn = 'TRN';
  for (let i = 0; i < 12; i++) {
    trn += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return trn;
};

export const generateARN = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let arn = 'ARN';
  for (let i = 0; i < 12; i++) {
    arn += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return arn;
};

export const calculateTax = (taxableValue, rate, isInterState = true) => {
  const value = parseFloat(taxableValue) || 0;
  const gstRate = parseFloat(rate) || 0;
  const totalTax = (value * gstRate) / 100;
  
  if (isInterState) {
    return {
      igst: totalTax.toFixed(2),
      cgst: '0.00',
      sgst: '0.00',
      total: totalTax.toFixed(2)
    };
  } else {
    const halfTax = totalTax / 2;
    return {
      igst: '0.00',
      cgst: halfTax.toFixed(2),
      sgst: halfTax.toFixed(2),
      total: totalTax.toFixed(2)
    };
  }
};

export const financialYears = [
  '2024-25',
  '2023-24',
  '2022-23',
  '2021-22'
];

export const months = [
  'April', 'May', 'June', 'July', 'August', 'September',
  'October', 'November', 'December', 'January', 'February', 'March'
];

export const quarters = [
  'April-June (Q1)',
  'July-September (Q2)',
  'October-December (Q3)',
  'January-March (Q4)'
];
